var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"3","viewBox":"0 0 14 3"}},[_c('line',{staticClass:"a",class:{red: _vm.red, green: _vm.green},attrs:{"x2":"14","transform":"translate(0 1.5)"}})])}
var staticRenderFns = []

export { render, staticRenderFns }